<template>
  <div>
    <div :class="['concept-blanknode-display', 'tree-node', { 'ml-12': leftMargin }]">
      <!--affichage des annotations anonymes en boucle-->

      <div v-for="(blanknode, i) in anonymousAndAnnotationsAxiomes" :key="i">

        <div :class="['flex-container', { 'blanknode-annonymous-container-level0': level0 }]">
          <span v-if="inAnnotationAxiom == false && level0" id="annonymous-property"
            class="property-value-prefix">&nbsp;&nbsp;&nbsp;</span>

          <div v-if="isAnnaonymous = isAnnaonymousAnnotations(blanknode)"
            :class="['annonymous-brace', 'brace-container-left']">
          </div>

          <div class="axiom-annotation-blanknode-container-content">

            <AxiomAnnotation v-if="blanknode.axiomAnnotations.length" :axiomAnnotations="blanknode.axiomAnnotations"
              :aProposDe="parentNode" />

            <div :id="accordionBasedId + '-' + other.key + '-container'" class="blanknode-container"
              v-for="(other, index) in othersOfAnonymousAnnotations(blanknode)" :key="index">
              <SmtAccordion :parentKey="parentKey + '-' + other.key" :accordion="checkAccordion(other.key)"
                :accordiontDisplayOpen="checkAccordiontDisplayOpen(other.key)" :predicat="other.key" :showTree=true
                :predicatTitle="other.title" :nombre="other.literals.length
                  + other.blankNodes.length" :isAnnaonymous="isAnnaonymous"
                :axiomAnnotations="blanknode.axiomAnnotations" :parentNode="parentNode"
                :inAnnotationAxiom="inAnnotationAxiom" :languages="other.languages"
                :isOnlyNotLocalizedLang="other.isOnlyNotLocalizedLang" :negative="other.negative"
                :simpleValues="other.literals" :blankNodes="other.blankNodes">

                <!--Affichage des propriétés/values-->
                <PropertyValue :values="other.literals" :treeDisplay="other.blankNodes.length > 0"
                  :showLanguageBadge="computedShowLanguageBadge(other)" :level0=true />
                <!-- Affichage des blanknodes enfants (appel recursif) -->
                <template v-if="other.blankNodes.length">
                  <AttributeBlankNode :blankNodes="other.blankNodes" :parentKey="parentKey + '-' + other.key"
                    :showLanguageBadge="showLanguageBadge" :braceDisplay="true" :parentNode="parentNode" />
                </template>
              </SmtAccordion>
            </div>
          </div>
        </div>
        <hr class="mr-12" v-if="separatorDisplay && i != (anonymousAndAnnotationsAxiomes.length - 1)"
          style="margin-bottom: 0px;margin-top: 0px;" />
      </div>
    </div>



    <!--affichage des annotations anonymes en boucle-->
    <div :id="accordionBasedId + '-' + axiomLogic.key + '-container'"
      :class="['blanknode-container', 'axiom-logic-container-content', { 'blanknode-logic-container-level0': level0 }, { 'ml-12': leftMargin }]"
      v-for="(axiomLogic, index) in logicAxiomes" :key="index">


      <template v-if="axiomLogicOperand">
        <span class="axiome-logique-operand ml-5" v-text="showFirstOperand || index != 0 ? axiomLogicOperand : ' '" />
      </template>

      <span :class="[{ 'property-value-prefix': level0 }]">&nbsp;&nbsp;&nbsp;</span>

      <template v-if="logicAxiomes.length">
        <!---------------------------------------->
        <!-- Gestion du maxQualifiedCardinality -->
        <!---------------------------------------->
        <template v-if="maxQualifiedCardinality(axiomLogic.other)">
          <LogicalAxiomeMaxQualifiedCardinality :showLanguageBadge="showLanguageBadge"
            :maxQualifiedCardinality="extractMaxQualifiedCardinalityValue(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onDataRangeLiterals="onDataRangeLiterals(axiomLogic.other)"
            :onDataRangeBlanknodes="onDataRangeBlanknodes(axiomLogic.other)"
            :onClassLiterals="onClassLiterals(axiomLogic.other)"
            :onClassBlanknodes="onClassBlanknodes(axiomLogic.other)" :level0="level0" />
        </template>


        <!---------------------------------------->
        <!-- Gestion du minQualifiedCardinality -->
        <!---------------------------------------->
        <template v-else-if="minQualifiedCardinality(axiomLogic.other)">
          <LogicalAxiomeMinQualifiedCardinality :showLanguageBadge="showLanguageBadge"
            :minQualifiedCardinality="extractMinQualifiedCardinalityValue(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onDataRangeLiterals="onDataRangeLiterals(axiomLogic.other)"
            :onDataRangeBlanknodes="onDataRangeBlanknodes(axiomLogic.other)"
            :onClassLiterals="onClassLiterals(axiomLogic.other)"
            :onClassBlanknodes="onClassBlanknodes(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du minCardinality -->
        <!---------------------------------------->
        <template v-else-if="minCardinality(axiomLogic.other)">
          <LogicalAxiomeMinCardinality :minCardinality="extractMinCardinalityValue(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)" :showLanguageBadge="showLanguageBadge"
            :level0="level0" />
        </template>


        <!---------------------------------------->
        <!-- Gestion du maxCardinality  -->
        <!---------------------------------------->
        <template v-else-if="maxCardinality(axiomLogic.other)">
          <LogicalAxiomeMaxCardinality :maxCardinality="extractMaxCardinalityValue(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)" :showLanguageBadge="showLanguageBadge"
            :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du qualifiedCardinality -->
        <!---------------------------------------->
        <template v-else-if="qualifiedCardinality(axiomLogic.other)">
          <LogicalAxiomeQualifiedCardinality :showLanguageBadge="showLanguageBadge"
            :qualifiedCardinality="extractQualifiedCardinalityValue(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onDataRangeLiterals="onDataRangeLiterals(axiomLogic.other)"
            :onDataRangeBlanknodes="onDataRangeBlanknodes(axiomLogic.other)"
            :onClassLiterals="onClassLiterals(axiomLogic.other)"
            :onClassBlanknodes="onClassBlanknodes(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du cardinality -->
        <!---------------------------------------->
        <template v-else-if="cardinality(axiomLogic.other)">
          <LogicalAxiomeCardinality :showLanguageBadge="showLanguageBadge"
            :onProperty="extractOnProperty(axiomLogic.other)"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :cardinality="extractCardinalityValue(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du hasSelf   -->
        <!---------------------------------------->
        <template v-else-if="hasSelf(axiomLogic.other)">
          <LogicalAxiomeHasSelf :showLanguageBadge="showLanguageBadge" :hasSelf="extractOnProperty(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du hasValue  -->
        <!---------------------------------------->
        <template v-else-if="hasValue(axiomLogic.other)">
          <LogicalAxiomeHasValue :showLanguageBadge="showLanguageBadge"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)" :hasValue="extractHasValue(axiomLogic.other)"
            :blankNodes="extractOnProperty(axiomLogic.other).blankNodes" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du someValuesFrom  -->
        <!---------------------------------------->
        <template v-else-if="someValuesFrom(axiomLogic.other)">
          <LogicalAxiomeSomeValuesFrom :showLanguageBadge="showLanguageBadge"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :someValuesFrom="extractSomeValuesFrom(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du allValuesFrom  -->
        <!---------------------------------------->
        <template v-else-if="allValuesFrom(axiomLogic.other)">
          <LogicalAxiomeAllValuesFrom :showLanguageBadge="showLanguageBadge"
            :onPropertyBlanknodes="onPropertyBlanknodes(axiomLogic.other)"
            :onPropertyLiterals="onPropertyLiterals(axiomLogic.other)"
            :allValuesFrom="extractAllValuesFrom(axiomLogic.other)" :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du oneOf   -->
        <!---------------------------------------->
        <template v-else-if="oneOf(axiomLogic.other)">
          <LogicalAxiomeOneOf :oneOf="extractOneOf(axiomLogic.other)" :showLanguageBadge="showLanguageBadge"
            :level0="level0" />
        </template>

        <!---------------------------------------->
        <!-- Gestion du complementOf   -->
        <!---------------------------------------->
        <template v-else-if="complementOf(axiomLogic.other)">
          <LogicalAxiomeComplementOf :complementOf="extractComplementOf(axiomLogic.other)"
            :showLanguageBadge="showLanguageBadge" :level0="level0" />
        </template>


        <!---------------------------------------->
        <!-- Gestion du intersectionOf   -->
        <!---------------------------------------->
        <template v-else-if="intersectionOf(axiomLogic.other)">
          <LogicalAxiomeIntersectionOf :showLanguageBadge="showLanguageBadge"
            :otherIntersectionOf="extractIntersectionOf(axiomLogic.other)" :level0="level0" />
        </template>


        <!---------------------------------------->
        <!-- Gestion du unionOf   -->
        <!---------------------------------------->
        <template v-else-if="unionOf(axiomLogic.other)">
          <LogicalAxiomeUnionOf :showLanguageBadge="showLanguageBadge" :otherUnionOf="extractUnionOf(axiomLogic.other)"
            :level0="level0" />
        </template>


        <SmtAccordion v-else :parentKey="parentKey + '-' + axiomLogic.key" :accordion="checkAccordion(axiomLogic.key)"
          :accordiontDisplayOpen="checkAccordiontDisplayOpen(other.key)" :showTree=false :nombre="1"
          v-for="(other, index) in axiomLogic.other" :key="index">
          <AttributeValueLogicalAxiom :other="other" :showLanguageBadge="showLanguageBadge" :leftMargin="false"
            :displayPrefixOperand="level0" :level0="level0" />
        </SmtAccordion>

      </template>
    </div>
  </div>
</template>

<script>
import BlankNodeTypeEnum from "../../enums/BlankNodes";
import AxiomeLogicKeysEnum from "../../enums/AxiomeLogicKeysEnum";
import AttributeValueLogicalAxiom from './AttributeValueLogicalAxiom';
import StoreConfiguration from "../../store-configuration";
import Utils from "../../utils";

export default {
  name: "AttributeBlankNode",
  components: {
    AttributeValueLogicalAxiom
  },
  data() {
    return {
      storeConfiguration: StoreConfiguration.state
    }
  },

  methods: {
    intersectionOf: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.INTERSECTION_OF);
    },

    unionOf: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.UNION_OF);
    },

    complementOf: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.COMPLEMENT_OF);
    },

    oneOf: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.ONE_OF);
    },

    allValuesFrom: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.ALL_VALUES_FROM);
    },

    someValuesFrom: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.SOME_VALUES_FROM);
    },

    hasValue: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.HAS_VALUE);
    },

    hasSelf: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.HAS_SELF);
    },

    cardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.CARDINALITY);
    },

    maxCardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.MAX_CARDIALITY);
    },

    qualifiedCardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.QUALIFIED_CARDINALITY);
    },

    minQualifiedCardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.MIN_QUALIFIED_CARDINALITY);
    },
    maxQualifiedCardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.MAX_QUALIFIED_CARDINALITY);
    },
    minCardinality: function (others) {
      return this.checkAxiomeLogiqueType(others, AxiomeLogicKeysEnum.MIN_CARDINALITY);
    },

    extractBaseOther: function (others, type) {
      let otherResult = [];
      others.forEach(other => {
        if (other.key === type) {
          otherResult.push(other);
        }
      });
      return otherResult;
    },

    extractAllValuesFrom: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.ALL_VALUES_FROM);
    },

    extractIntersectionOf: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.INTERSECTION_OF);
    },

    extractUnionOf: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.UNION_OF);
    },

    extractComplementOf: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.COMPLEMENT_OF);
    },
    extractOneOf: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.ONE_OF);
    },
    extractSomeValuesFrom: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.SOME_VALUES_FROM);
    },

    extractHasValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.HAS_VALUE);
    },

    extractMaxCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.MAX_CARDIALITY);
    },

    extractQualifiedCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.QUALIFIED_CARDINALITY);
    },


    extractCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.CARDINALITY);
    },

    extractMinQualifiedCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.MIN_QUALIFIED_CARDINALITY);
    },

    extractMaxQualifiedCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.MAX_QUALIFIED_CARDINALITY);
    },

    extractMinCardinalityValue: function (others) {
      return this.extractBaseOther(others, AxiomeLogicKeysEnum.MIN_CARDINALITY);
    },

    checkAxiomeLogiqueType: function (others, type) {
      let match = false;
      if (others.length > 0) {
        others.forEach(other => {
          if (other.key === type) {
            match = true;
          }
        });
      }
      return match;
    },

    extractOnDataRange: function (others) {
      let result = [];
      others.forEach(other => {
        if (other.key === AxiomeLogicKeysEnum.ON_DATA_RANGE) {
          result.push(other);
        }
      });
      return result;
    },
    extractOnClass: function (others) {
      let result = [];
      others.forEach(other => {
        if (other.key === AxiomeLogicKeysEnum.ON_CLASS) {
          result.push(other);
        }
      });
      return result;
    },
    extractOnProperty: function (others) {
      let result = [];
      others.forEach(other => {
        if (other.key === AxiomeLogicKeysEnum.ON_PROPERTY) {
          result.push(other);
        }
      });
      return result;
    },

    onPropertyBlanknodes(others) {
      let onProperty = this.extractOnProperty(others);
      let blankNodes = [];
      onProperty.forEach(element => {
        blankNodes.push(...element.blankNodes);
      });
      return blankNodes;
    },
    onPropertyLiterals(others) {
      let onProperty = this.extractOnProperty(others);
      let literals = [];
      onProperty.forEach(element => {
        literals.push(...element.literals);
      });

      // Les property ne s'affichent pas en tant que lien hypertexte
      literals.forEach(element => {
        element.content = Utils.extractLabelFromHyperlink(element.content);
      });
      return literals;
    },
    onDataRangeLiterals(others) {
      let onDataRange = this.extractOnDataRange(others);
      let result = [];
      onDataRange.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    onDataRangeBlanknodes(others) {
      let onDataRange = this.extractOnDataRange(others);
      let result = [];
      onDataRange.forEach(element => {
        result.push(...element.blankNodes);
      });
      return result;
    },
    onClassLiterals(others) {
      let onClass = this.extractOnClass(others);
      let result = [];
      onClass.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    },
    onClassBlanknodes(others) {
      let onClass = this.extractOnClass(others);
      let result = [];
      onClass.forEach(element => {
        result.push(...element.blankNodes);
      });
      return result;
    },
    /**
     * 
     * @param attribute Retourne si l'attribut doit être affiché dans un accordeon ouvert ou fermé par défaut
     */
    checkAccordiontDisplayOpen: function (attribute) {
      let show = true;
      if (this.storeConfiguration.current?.concepts_details?.affichage?.avec_accordeon && attribute in this.storeConfiguration.current.concepts_details.affichage.avec_accordeon
        && this.storeConfiguration.current.concepts_details.affichage.avec_accordeon[attribute].etat !== 'none') {
        show = this.storeConfiguration.current.concepts_details.affichage.avec_accordeon[attribute].etat === 'open';
      }
      return show;
    },
    /**
     * 
     * @param attribute Retourne si l'attribut doit être affiché dans un accordeon
     */
    checkAccordion: function (attribute) {
      return (this.storeConfiguration.current?.concepts_details?.affichage?.avec_accordeon && attribute in this.storeConfiguration.current.concepts_details.affichage.avec_accordeon
        && this.storeConfiguration.current.concepts_details.affichage.avec_accordeon[attribute].etat !== 'none');
    },

    /**
     * Extraction other of annotated et anymous annotations
     */
    othersOfAnonymousAnnotations(bl) {
      if (bl == undefined) {
        return [];
      }
      let othersOfAnonymousAnnotations = [];

      let otherPerKey = new Map();

      bl.other.forEach(th => {
        if (otherPerKey.has(th.key)) {
          otherPerKey.get(th.key).push(th);
        } else {
          otherPerKey.set(th.key, [th]);
        }
      });

      // Fusionner les other qui ont la même clé
      otherPerKey.forEach((other, key) => {
        let values = [];
        let blankNodes = [];
        let title = '';
        let negative = false;
        other.forEach(o => {
          if (o.negative) {
            negative = true;
          }
          title = o.title;
          values.push(...o.literals);
          blankNodes.push(...o.blankNodes);
        });
        // Calculer languages et isOnlyNotLocalizedLang pour cet élément
        const { languages, isOnlyNotLocalizedLang } = Utils.processLanguages(blankNodes, this.storeConfiguration, values);
        othersOfAnonymousAnnotations.push({
          key: key,
          title: title,
          literals: values,
          negative: negative,
          blankNodes: blankNodes,
          languages: languages,
          isOnlyNotLocalizedLang: isOnlyNotLocalizedLang
        });
      });
      return othersOfAnonymousAnnotations;
    },
    isAnnaonymousAnnotations(blanknode) {
      return blanknode.blankNodeType === BlankNodeTypeEnum.ANONYMOUS_ANNOTATION;
    },
    computedShowLanguageBadge(other) {
      return this.inAnnotationAxiom && other.languages.length > 0 ? true : this.showLanguageBadge;
    }
  },
  computed: {

    /**
     * Return un id unique pour l'accordeon en évitant les espaces et les majuscules
     */
    accordionBasedId() {
      return `blanknode-${this.parentKey}`.toLowerCase().replace(/\s+/g, '');
    },
    /**
     * Retroune le fait d'avoir des blanknodes ou non
     */
    hasBlanknodes() {
      return this.blankNodes.length > 0;
    },
    /**
     * Extraction des annotations anonymes et Annotations d'axiomes 
     */
    anonymousAndAnnotationsAxiomes() {
      let axiomes = [];
      this.blankNodes.forEach(bl => {
        if (bl.blankNodeType === BlankNodeTypeEnum.ANONYMOUS_ANNOTATION || bl.blankNodeType === BlankNodeTypeEnum.AXIOM_ANNOTATION) {
          axiomes = axiomes.concat(bl);
        }
      });
      return axiomes;
    },

    /**
     * Extraction des axiomes logiques
     */
    logicAxiomes() {
      let logicAxiomes = [];
      this.blankNodes.forEach(bl => {
        if (bl.blankNodeType === BlankNodeTypeEnum.LOGICAL_AXIOM) {
          logicAxiomes.push(bl);
        }
      });
      return logicAxiomes;
    },

    /**
     * Extraction des axiomes d'annotations
     */
    axiomesAnnotations() {
      let axiomesAnnotations = [];
      this.blankNodes.forEach(bl => {
        if (bl.blankNodeType === BlankNodeTypeEnum.AXIOM_ANNOTATION) {
          axiomesAnnotations.push(bl);
        }
      });
      return axiomesAnnotations;
    },
  },
  props: {
    level0: {
      type: Boolean,
      default: false,
    },
    showFirstOperand: {
      type: Boolean,
      default: false,
    },
    axiomLogicOperand: {
      type: String,
      default: ''
    },
    separatorDisplay: {
      type: Boolean,
      default: false,
    },
    braceDisplay: {
      type: Boolean,
      default: true,
    },
    parentKey: {
      type: String,
      default: ''
    },
    parentNode: {
      type: String,
      default: ''
    },
    blankNodes: {
      type: Array,
      default: () => []
    },
    accordion: {
      type: Boolean,
      default: true,
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    },
    leftMargin: {
      type: Boolean,
      default: true
    },
    inAnnotationAxiom: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
.blanknode-predicat-container {
  display: flex;
}

.flex-container {
  display: flex;
  padding: 6px;
}

.blanknode-container {
  display: flex;
  flex-direction: row;
}

.blanknode-accordion-button::before {
  content: "▼";
  display: inline-block;
  margin-right: 5px;
}

.blanknode-accordion-button.collapsed {
  transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
}

#annonymous-property {
  align-content: center;
  margin-left: -7px;
}

.annotation-axiome-container {
  position: absolute;
  top: -10px;
  right: 0;
  /* Additional styling as needed */
}

::v-deep .brace-container-left {
  border-top: 2px solid #1d71b8;
  border-bottom: 2px solid #1d71b8;
  border-left: 2px solid #1d71b8;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  min-width: 10px;
  align-items: stretch;
}

::v-deep .brace-container-right {
  border-top: 2px solid #1d71b8;
  border-bottom: 2px solid #1d71b8;
  border-right: 2px solid #1d71b8;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  width: 10px;
  margin-left: 10px;
  margin-right: 10px;
  align-items: stretch;
}

::v-deep .axiome-logique-operand {
  color: var(--v-secondary-base);
  min-width: 30px;
}

::v-deep .axiome-logique-container {
  display: flex;
}

::v-deep .property-value-prefix {
  align-items: center;
  text-decoration: line-through;
  color: #1d71b8;
  margin-right: 10px;
}
</style>